var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-field",
        { attrs: { label: _vm.title, "label-position": "on-border" } },
        [
          [
            _c(
              "b-field",
              [
                _vm.type === "select"
                  ? _c(
                      "b-select",
                      {
                        attrs: {
                          id: _vm.id,
                          placeholder: _vm.placeholder,
                          rounded: "",
                          expanded: "",
                        },
                        model: {
                          value: _vm.formattedInput,
                          callback: function ($$v) {
                            _vm.formattedInput = $$v
                          },
                          expression: "formattedInput",
                        },
                      },
                      _vm._l(_vm.options, function (option, j) {
                        return _c(
                          "option",
                          {
                            key: `option-${j}`,
                            domProps: { value: option.value },
                          },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        )
                      }),
                      0
                    )
                  : _vm.type === "switch" && _vm.termType === _vm.selfTermType
                  ? _c(
                      "b-switch",
                      _vm._b(
                        {
                          attrs: { id: _vm.id },
                          model: {
                            value: _vm.formattedInput,
                            callback: function ($$v) {
                              _vm.formattedInput = $$v
                            },
                            expression: "formattedInput",
                          },
                        },
                        "b-switch",
                        _vm.$attrs,
                        false
                      ),
                      [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]
                    )
                  : _vm.type === "text"
                  ? _c(
                      "b-input",
                      _vm._b(
                        {
                          attrs: {
                            id: _vm.id,
                            type: _vm.type,
                            rounded: "",
                            icon: _vm.icon || "",
                            placeholder: _vm.placeholder,
                            expanded: "",
                          },
                          model: {
                            value: _vm.formattedInput,
                            callback: function ($$v) {
                              _vm.formattedInput = $$v
                            },
                            expression: "formattedInput",
                          },
                        },
                        "b-input",
                        _vm.$attrs,
                        false
                      )
                    )
                  : _vm.type === "number"
                  ? _c(
                      "b-input",
                      _vm._b(
                        {
                          attrs: {
                            id: _vm.id,
                            rounded: "",
                            icon: _vm.icon || "",
                            placeholder: _vm.placeholder,
                            expanded: "",
                          },
                          model: {
                            value: _vm.formattedInput,
                            callback: function ($$v) {
                              _vm.formattedInput = $$v
                            },
                            expression: "formattedInput",
                          },
                        },
                        "b-input",
                        _vm.$attrs,
                        false
                      )
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }